// extracted by mini-css-extract-plugin
export var downArrow = "_af-0";
export var label = "_af-1";
export var treatmentCard = "_af-3";
export var upArrow = "_af-2";